import * as Yup from "yup";

export const schoolLeaderQuestions = () =>
  Yup.object().shape({
    InfrastructureAndFacilities: Yup.array().min(1).of(Yup.string().required()),
    AcademicOffers: Yup.array().min(1).of(Yup.string().required()),
    AvailableAcademicSystems: Yup.array().min(1).of(Yup.string().required()),
    ClassesOffered: Yup.array().min(1).of(Yup.string().required()),
    gender: Yup.array().min(1).of(Yup.string().required()),
    EducationalStaff: Yup.array().min(1).of(Yup.string().required()),
    SupportStudents: Yup.array().min(1).of(Yup.string().required()),
    HealthAndSafety: Yup.array().min(1).of(Yup.string().required()),
    ExtraCurricularActivities: Yup.array().min(1).of(Yup.string().required()),
    CommunityInvolvement: Yup.array().min(1).of(Yup.string().required()),
    TechnologyAndResources: Yup.array().min(1).of(Yup.string().required()),
    Transport: Yup.array().min(1).of(Yup.string().required()),
    SpecialPrograms: Yup.array().min(1).of(Yup.string().required()),
    ParentParticipation: Yup.array().min(1).of(Yup.string().required()),
    StudentConductAndDiscipline: Yup.array().min(1).of(Yup.string().required()),
    CareerPreparation: Yup.array().min(1).of(Yup.string().required()),
    CommunicationWithParents: Yup.array().min(1).of(Yup.string().required()),
    other: Yup.array().min(1).of(Yup.string().required()),
  });
